import { render, staticRenderFns } from "./ClientInfos.vue?vue&type=template&id=5098c142"
import script from "./ClientInfos.vue?vue&type=script&lang=js"
export * from "./ClientInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports